// DS: i4.39
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const PremiumGallery: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 3H19.5C20.3284 3 21 3.67157 21 4.5V17H19V5.6C19 5.26863 18.7314 5 18.4 5H7V3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 8.5C3 7.67157 3.67157 7 4.5 7H15.5C16.3284 7 17 7.67157 17 8.5V19.5C17 20.3284 16.3284 21 15.5 21H4.5C3.67157 21 3 20.3284 3 19.5V8.5ZM11.955 11.0663L13.5476 11.8947C13.7152 11.9818 13.8182 12.1418 13.8182 12.3148V14.4651C13.8182 14.604 13.7516 14.7363 13.6352 14.8286L10.3624 17.4226C10.1558 17.5864 9.84435 17.5864 9.63769 17.4226L6.36496 14.8286C6.24851 14.7363 6.18188 14.604 6.18188 14.4651V12.3148C6.18188 12.1418 6.28493 11.9818 6.4525 11.8947L8.04512 11.0663C8.23758 10.9662 8.47896 10.9805 8.65484 11.1025L10.0001 12.0354L11.3453 11.1025C11.5212 10.9805 11.7626 10.9662 11.955 11.0663Z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);
PremiumGallery.displayName = 'PremiumGallery';

export default PremiumGallery;
